import { UrlHelper as PortfolioUrlHelper } from '@ecm/portfolio';

/**
 * Utility class for URL manipulation and domain checking
 */
export class UrlHelper {
    /**
     * Performs CID regex match on given url
     * @deprecated use `UrlHelper.matchCid` from `ecm-portfolio` instead
     * @param {string} url
     * @returns {string[]}
     */
    // eslint-disable-next-line deprecation/deprecation -- bug in deprecation plugin
    static matchCid(url: string): string[] {
        return PortfolioUrlHelper.matchCid(url);
    }

    /**
     * Checks if provided url is external
     * @deprecated use `UrlHelper.matchCid` from `ecm-portfolio` instead
     * @param {string} url
     * @returns {boolean}
     */
    // eslint-disable-next-line deprecation/deprecation -- bug in deprecation plugin
    static isExternalUrl(url: string): boolean {
        return PortfolioUrlHelper.isExternalUrl(url);
    }

    /**
     * Checks if provided url matches `.orange.fr` domain
     * @param {string} url
     * @returns {boolean}
     */
    static isOrangeUrl(url: string): boolean {
        return UrlHelper.isDomainUrl(url, '.orange.fr');
    }

    /**
     * Checks if provided url matches `.sosh.fr` domain
     * @param {string} url
     * @returns {boolean}
     */
    static isSoshUrl(url: string): boolean {
        return UrlHelper.isDomainUrl(url, '.sosh.fr');
    }

    /**
     * Checks if provided url matches `.orange.fr` or `.sosh.fr` domain
     * Source tracking parameter should only be added to these domains
     * @param {string} url
     * @returns {boolean}
     */
    static isOrangeOrSoshDomain(url: string): boolean {
        return UrlHelper.isOrangeUrl(url) || UrlHelper.isSoshUrl(url);
    }

    /**
     * Checks if provided url matches provided domain
     * @param {string} url
     * @param {string} domain
     * @returns {boolean}
     */
    static isDomainUrl(url: string, domain: string): boolean {
        const hostName: string = UrlHelper.getHostnameFromUrl(url);
        return hostName ? hostName.endsWith(domain) : false;
    }

    /**
     * Extracts hostname from provided url
     * @param {string} url
     * @returns {string}
     */
    static getHostnameFromUrl(url: string): string {
        if (<any>window.document) {
            // instantiate native anchor element to extract hostname
            const link = document.createElement('a');
            link.href = url;
            return link.hostname;
        }
        return null;
    }
}
